import { Paper, styled } from '@mui/material';
import { Async } from '~/shared/tools/async';
import { AsyncView } from './view.async';
import { BoxProps, Col, FCC } from './view.box';

const StyledPaper = styled(Paper)({
	padding: '16px 24px',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	justifySelf: 'center',
	gap: 24,
	maxWidth: 'max-content',
});

export const EditContainer: FCC<{ async: Async }> = ({ children, async }) => {
	return (
		<AsyncView async={async}>
			<StyledPaper elevation={1}>{children}</StyledPaper>
		</AsyncView>
	);
};

export const EditLeft: FCC<BoxProps> = ({ children, ...props }) => {
	return (
		<Col justifyContent="flex-start" mr={4}>
			<Col justifyContent={'flex-start'} gap={2} position="sticky" top={80} {...props}>
				{children}
			</Col>
		</Col>
	);
};

export const EditCenter: FCC<BoxProps> = ({ children, ...props }) => {
	return (
		<Col justifyContent="flex-start" flexGrow={1} gap={2} flex={1}>
			<Col justifyContent={'flex-start'} gap={2} position="sticky" top={80} minWidth={600} {...props}>
				{children}
			</Col>
		</Col>
	);
};

export const EditRight: FCC = ({ children }) => {
	return (
		<Col justifyContent="flex-start" gap={2} minWidth={180}>
			<Col justifyContent="flex-start" gap={2} position="sticky" top={80}>
				{children}
			</Col>
		</Col>
	);
};
